import {MdLiveHelp} from 'react-icons/md';
import isLocalOrDevEnvironment from '../../lib/isLocalOrDevEnvironment.ts';

const HelpButton = ({className}: {className: string}) => {
    const toggleHelpfruitBot = () => {
        const enableBotOnLocalhost =
            localStorage.getItem('enableBotOnLocalhost') === 'true';
        const shouldHaveBot = !isLocalOrDevEnvironment || enableBotOnLocalhost;

        if (!shouldHaveBot) {
            alert(
                'Helpfruit bot is not enabled on localhost. Set enableBotOnLocalhost=true on local storage to enable.'
            );
            return;
        }

        const botOpen = JSON.parse(
            sessionStorage.getItem('FaqbotOpened') ?? 'false'
        );
        if (window.faqbot) {
            if (botOpen) {
                window.faqbot.close();
            } else {
                window.faqbot.open();
            }
        }
    };

    return (
        <button
            onClick={toggleHelpfruitBot}
            className={className}
            aria-label={'Show Help'}
        >
            <MdLiveHelp size={20} />
        </button>
    );
};

export default HelpButton;
